import { useMemo } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";

import { SegmentTemplate, TemplateType } from "../models/SegmentTemplate";
import useExtendSegments from "../utils/ExtendSegment";
import useInitialSegments from "../utils/InitialSegment";
import {
  updateOneSegmentTerminalDecline,
  updateSAGD,
  updateThreeSegmentTerminalDecline,
  updateThreeSegmentTerminalDeclineWithConstrainedPeriod,
  updateThreeSegmentTerminalDeclineWithRampUp,
  updateTwoSegmentTerminalDecline,
  updateTwoSegmentTerminalDeclineWithRampUp
} from "../utils/updateSegment";

export default function useSegmentTemplates(): SegmentTemplate[] {
  const typeWellSettings = useSelector(
    (state: RootState) => state.userSetting.typeWellSettings
  );

  const {
    initialOneSegmentTerminalDecline,
    initialSAGD,
    initialTwoSegmentTerminalDecline,
    initialTwoSegmentTerminalDeclineWithRampUp,
    initialThreeSegmentTerminalDecline,
    initialThreeSegmentTerminalDeclineWithRampUp,
    initialThreeSegmentTerminalDeclineWithConstrainedPeriod
  } = useInitialSegments();

  const {
    extendOneSegmentTerminalDecline,
    extendSAGD,
    extendTwoSegmentTerminalDecline,
    extendTwoSegmentTerminalDeclineWithRampUp,
    extendThreeSegmentTerminalDecline,
    extendThreeSegmentTerminalDeclineWithRampUp,
    extendThreeSegmentTerminalDeclineWithConstrainedPeriod
  } = useExtendSegments();

  return useMemo(
    () => [
      {
        type: TemplateType.OneSegment,
        productCols: [],
        productDisplayData: [],
        update: updateOneSegmentTerminalDecline,
        initialData: initialOneSegmentTerminalDecline,
        extendArps: extendOneSegmentTerminalDecline
      } as SegmentTemplate,
      {
        type: TemplateType.TwoSegment,
        productCols: [],
        productDisplayData: [],
        update: updateTwoSegmentTerminalDecline,
        initialData: initialTwoSegmentTerminalDecline,
        extendArps: extendTwoSegmentTerminalDecline
      } as SegmentTemplate,
      {
        type: TemplateType.TwoSegmentWithRampUp,
        productCols: [],
        productDisplayData: [],
        update: updateTwoSegmentTerminalDeclineWithRampUp,
        initialData: initialTwoSegmentTerminalDeclineWithRampUp,
        extendArps: extendTwoSegmentTerminalDeclineWithRampUp
      } as SegmentTemplate,
      {
        type: TemplateType.ThreeSegment,
        productCols: [],
        productDisplayData: [],
        update: updateThreeSegmentTerminalDecline,
        initialData: initialThreeSegmentTerminalDecline,
        extendArps: extendThreeSegmentTerminalDecline
      } as SegmentTemplate,
      {
        type: TemplateType.ThreeSegmentWithRampUp,
        productCols: [],
        productDisplayData: [],
        update: updateThreeSegmentTerminalDeclineWithRampUp,
        initialData: initialThreeSegmentTerminalDeclineWithRampUp,
        extendArps: extendThreeSegmentTerminalDeclineWithRampUp
      } as SegmentTemplate,
      {
        type: TemplateType.ThreeSegmentWithConstrainedPeriod,
        productCols: [],
        productDisplayData: [],
        update: updateThreeSegmentTerminalDeclineWithConstrainedPeriod,
        initialData: initialThreeSegmentTerminalDeclineWithConstrainedPeriod,
        extendArps: extendThreeSegmentTerminalDeclineWithConstrainedPeriod
      } as SegmentTemplate,
      {
        type: TemplateType.SAGD,
        productCols: [],
        productDisplayData: [],
        update: updateSAGD,
        initialData: initialSAGD,
        extendArps: extendSAGD
      } as SegmentTemplate
    ],
    [typeWellSettings]
  );
}
